import LittleCaesars from '@/assets/images/sponsors/Little_Caesars.webp'
import AKKODiS from '@/assets/images/sponsors/Akkodis.webp'
import AXIOM from '@/assets/images/sponsors/AXIOM.webp'
import SpinDance from '@/assets/images/sponsors/SpinDance.webp'
import MongoDB from '@/assets/images/sponsors/MongoDB.webp'
import RIIS from '@/assets/images/sponsors/RIIS.webp'

export const sponsorsData = [
  {
    id: 1,
    name: 'Little Caesars',
    logo: LittleCaesars,
    desc: `Headquartered in Detroit, Michigan, Little Caesars was founded by Mike and Marian Ilitch in 1959 as a single, family-owned restaurant. Today Little Caesars is the third largest pizza chain in the world with stores in each of the 50 U.S. states and 27 countries and territories.`,
    url: 'https://littlecaesars.com/en-us/',
  },
  {
    id: 2,
    name: 'AXIOM',
    logo: AXIOM,
    desc: `Axiom reinvents log management for high-scale engineering. Handle massive data volumes with ease while significantly reducing costs, leveraging cloud-native architecture and a thoughtful approach to data management.`,
    url: 'https://axiom.co/',
  },
  {
    id: 3,
    name: 'RIIS',
    logo: RIIS,
    desc: `RIIS LLC is a mobile and web development company that specializes in creating drone applications.`,
    url: 'https://www.riis.com/',
  },
  {
    id: 4,
    name: 'SpinDance',
    logo: SpinDance,
    desc: `SpinDance, trusted leaders in tech, looking to simplify the complex and connect the physical to the invisible. Every day, we partner with many kinds of organizations to build and manage the software that powers today's smart devices. Our services guide you to discover a value-driven IoT project that aligns with your company's vision and goals. And our end-to-end approach and tech stack help you develop a state-of-the-art IoT solution, one that offers data-driven innovation at its finest.`,
    url: 'https://spindance.com/',
  },
  {
    id: 5,
    name: 'AKKODiS',
    logo: AKKODiS,
    desc: `As part of the Adecco Group, the worldwide leader in talent advisory and solutions, Akkodis is a dynamic company poised to lead in the rapidly evolving fields of technology and engineering. With a strong international presence, Akkodis tailors its services to meet local needs while fostering innovation through collaboration in the areas of Talent, Academy, Consulting and Solutions. Committed to sustainability and talent development, Akkodis integrates IT and engineering expertise, delivering com`,
    url: 'https://www.akkodis.com/',
  },
  {
    id: 6,
    name: 'MongoDB',
    logo: MongoDB,
    desc: `Build applications on the industry's first developer data platform. From AI-powered and event-driven apps to edge use cases and search, build fast and at the scale users demand.`,
    url: 'https://www.mongodb.com/',
  },
]
